export default __webpack_public_path__ + "static/media/list-cost-recruit.9dbd1f3c.svg";